<script>
	import {get} from "svelte/store";
	import Papa from "papaparse";
	import ModalWindow from "../ModalWindow.svelte";
	import "./CustomGeoJSONOverlayForm.scss";

	import Radio from "@smui/radio";
	import FormField from '@smui/form-field';

	import Form from '../Admin/Form.svelte';

	import Button, {Label} from '@smui/button';
	import DataTable, {Head, Body, Row, Cell} from '@smui/data-table';
	import {HsvPicker} from 'svelte-color-picker';

	import MapControlType from "../../Map/Enums/MapControlType";
	import MapStore from "../../Map/Store";
	import MapLayerManager from "../../Map/MapLayerManager";

	import GeoHelper from "../../Helpers/GeoHelper";
	import ColorHelper from "../../Helpers/ColorHelper";

	import InputType from "./InputType";
	import ShapeType from "./ShapeType";

	/*
		TODO:
		- (optional) store on server checkbox
		- ensure that properties of each point are added to feature.properties.
		- success text, auto close.
	*/


	let inputType = InputType.CSV;
	let inputFileTypes = ".csv";
	let csvShapeType = ShapeType.POLYGON;
	let csvValidFields = [];
	let csvUseLngField = null;
	let csvUseLatField = null;

	let colorPickVisible = false;
	let toggleColorPickerVisibility = () => {
		colorPickVisible = !colorPickVisible;
	};
	let color = [0,0,0,1];
	let colorHex = "#000000";

	let customGeojsonVisible = MapStore.controlData.customGeojson.visible;
	// let customGeojsonLayers = MapStore.controlData.customGeojson.layers;

	let style = "width:100%;margin-top:5px;";
	let errorStyle = "width:calc(100% - 20px);margin-top:10px;padding:10px;border-radius:3px;";
	let control = MapStore.control;

	let inputText = "";
	let error = false;
	let errorMessage = "";

	let resetError = () => {
		error = false;
		errorMessage = "";
	};
	let onClose = () => {
		$control = MapControlType.PAN;
		resetError();
	};
	let onInputFormatChange = () => {
		if (inputType == InputType.CSV) {
			inputFileTypes = ".csv";
		}
		else if (inputType == InputType.GEOJSON) {
			inputFileTypes = ".geojson,.json";
		}
		else {
			inputFileTypes = ".*";
		}
		resetError();
	};
	let onInputFileChanged = (e) => {
		const file = e.target.files[0];
		const reader = new FileReader();
		reader.onload = function(event) {
			let data = event.target.result;
			// inputType = InputType.CSV;
			inputText = data;
			onChange();
		}
		reader.readAsBinaryString(file);
	}

	let onChange = () => {
		error = false;
		errorMessage = "";
		if (inputType == InputType.CSV) {
			let result = Papa.parse(inputText, { header: true });
			console.log('result', result);
			if (result.errors.length > 0) {
				error = true;
				errorMessage = result.errors[0].message;
				return;
			}
			if (result.meta.fields.length < 2) {
				error = true;
				errorMessage = "CSV must contain at least two columns.";
				return;
			}
			let pointMin = (csvShapeType === ShapeType.POLYGON)
				? 3
				: (csvShapeType === ShapeType.LINE)
					? 2
					: 1;
			if (result.data.length < pointMin) { // 3 for poly, 2 for line, 1 for point(s)
				error = true;
				errorMessage = "CSV " + csvShapeType + " must contain at least " + pointMin + " rows.";
				return;
			}
			// We need to make sure we have lng/lat fields.
			const fields = result.meta.fields;
			csvUseLngField = pickField(fields, ["lng", "longitude", "lon", "x"]);
			csvUseLatField = pickField(fields, ["lat", "latitude", "y"]);

			csvValidFields = [];
			for(let i = 0; i < fields.length; i++) {
				const v = result.data[0][fields[i]];
				if (!Number.isNaN(parseFloat(v))) {
					csvValidFields.push(fields[i]);
				}
			}
			csvValidFields = csvValidFields;
		}
		else {
			let obj = JSON.parse(inputText);
			if (!obj) {
				error = true;
				errorMessage = "Invalid GeoJSON";
				return;
			}
		}
	};
	let pickField = (headerFields, preferenceOrder) => {
		for(let i = 0; i < preferenceOrder.length; i++) {
			const pref = preferenceOrder[i];
			const index = headerFields.indexOf(pref);
			if (index >= 0) {
				return pref;
				break;
			}
		}
		return null;
	};
	let onSubmit = () => {
		if (inputType == InputType.GEOJSON) {
			error = false;
			let result = MapLayerManager.addCustomGeoJSONLayer(inputText)
			if (!result) {
				error = true;
				errorMessage = "Invalid GeoJSON FeatureCollection";
				return;
			}
			let featureCollection = MapLayerManager.getNewestCustomGeoJSONLayer();
			for(let i = 0; i < featureCollection.features.length; i++) {
				if (typeof featureCollection.features[i].properties.color !== "string") {
					featureCollection.features[i].properties.color = colorHex;
				}
			}
			inputText = "";
			onClose();
		}
		else if (inputType == InputType.CSV) {
			error = false;
			let result = Papa.parse(inputText, { header: true });
			if (result.errors.length > 0) {
				error = true;
				errorMessage = result.errors[0].message;
			}
			// We need to make sure we have lng/lat fields.
			// const fields = result.meta.fields;
			// csvUseLngField = pickField(fields, ["lng", "longitude", "lon", "x"]);
			// csvUseLatField = pickField(fields, ["lat", "latitude", "y"]);
			if (csvUseLngField == null) {
				error = true;
				errorMessage = "Could not deduce longitude header from CSV. Please manually specify.";
			}
			else if (csvUseLatField == null) {
				error = true;
				errorMessage = "Could not deduce latitude header from CSV. Please manually specify.";
			}
			if (!error) {
				let pointsArray = result.data.map((row) => {
					return [row[csvUseLngField], row[csvUseLatField]];
				});
				let isSuccess = false;
				let featureCollection = null;
				if (csvShapeType === ShapeType.LINE || csvShapeType === ShapeType.POLYGON) {
					if (csvShapeType === ShapeType.LINE) {
						featureCollection = GeoHelper.featureCollectionLineString(pointsArray);
						featureCollection.features[0].properties.color = colorHex;
					}
					else if (csvShapeType === ShapeType.POLYGON) {
						pointsArray.push(pointsArray[0]);
						featureCollection = GeoHelper.featureCollectionPolygon(pointsArray);
						featureCollection.features[0].properties.color = colorHex;
					}
					if (featureCollection !== null) {
						let result = MapLayerManager.addCustomGeoJSONLayer(JSON.stringify(featureCollection));
						if (!result) {
							error = true;
							errorMessage = "Invalid GeoJSON FeatureCollection";
							return;
						}
						isSuccess = true;
					}
				}
				else if (csvShapeType === ShapeType.POINTS) {
					// featureCollection = GeoHelper.featureCollectionPoints(pointsArray);
					console.log("points", result.data);
					console.log("pointsArray", pointsArray);
					let currentMarkers = get(MapStore.controlData.draw.markers);
					for(let i = 0; i < pointsArray.length; i++) {
						result.data[i].lng = parseFloat(result.data[i][csvUseLngField]);
						result.data[i].lat = parseFloat(result.data[i][csvUseLatField]);
						result.data[i].color = colorHex;
						currentMarkers.push(result.data[i]);
					}
					MapStore.controlData.draw.markers.set(currentMarkers);
					MapLayerManager.updateCustomMarkers();
					isSuccess = true;
				}

				if (isSuccess) {
					inputText = "";
					$customGeojsonVisible = false;
					onClose();
				}

			}

			console.log('result', result);
		}
	};

</script>

<ModalWindow title={`Add Custom Geometry`} resizable={false} draggable={false} fullscreen={true} padding={true} hasCloseButton={true} hasBackground={true} on:close={onClose} bind:open={$customGeojsonVisible}>

	<Form id='add-custom-geometry-form'>
		<DataTable table$aria-label="User" style={style}>
			<Head style="display: none">
				<Row>
					<Cell></Cell>
					<Cell></Cell>
				</Row>
			</Head>
			<Body>
				<Row>
					<Cell>Input Format:</Cell>
					<Cell>
						<select class='default' bind:value={inputType} style="width:100%;" on:change={onInputFormatChange}>
							<option value={InputType.CSV} selected={inputType === InputType.CSV}>{InputType.CSV}</option>
							<option value={InputType.GEOJSON} selected={inputType === InputType.GEOJSON}>{InputType.GEOJSON}</option>
							<!-- <option value={InputType.UPLOAD_CSV} selected={inputType === InputType.UPLOAD_CSV}>{InputType.UPLOAD_CSV}</option>
							<option value={InputType.UPLOAD_GEOJSON} selected={inputType === InputType.UPLOAD_GEOJSON}>{InputType.UPLOAD_GEOJSON}</option> -->
						</select>
					</Cell>
				</Row>
				{#if inputType === InputType.CSV}
					<Row>
						<Cell>Shape Type:</Cell>
						<Cell>
							<select class='default' bind:value={csvShapeType} style="width:100%;">
								<option value={ShapeType.POLYGON} selected={csvShapeType === ShapeType.POLYGON}>{ShapeType.POLYGON}</option>
								<option value={ShapeType.LINE} selected={csvShapeType === ShapeType.LINE}>{ShapeType.LINE}</option>
								<option value={ShapeType.POINTS} selected={csvShapeType === ShapeType.POINTS}>{ShapeType.POINTS}</option>
							</select>
						</Cell>
					</Row>
				{/if}

					<Row>
						<Cell>{inputType}:</Cell>
						<Cell>
							<div class='bg-info' style='margin-top:5px;padding:10px;border-radius:3px;'><b>Upload file or copy & paste data...</b></div>
							<input type="file" on:change={onInputFileChanged} id="files" class="form-control" accept={inputFileTypes} placeholder="Upload file..." style='margin-top:5px;'/>

							<textarea class='long-textarea input-geojson' placeholder={`Input ${inputType} data...`} bind:value={inputText} on:change={onChange} on:input={onChange} style='min-height:150px;'></textarea>
						</Cell>
					</Row>

				{#if inputType === InputType.CSV && inputText.length > 0}
					<Row>
						<Cell>Plot:</Cell>
						<Cell>
							<p><b>Longitude:</b></p>
							<select class='default' bind:value={csvUseLngField} style="width:100%;">
								<option value={null} selected={csvUseLngField === null}>Please select:</option>
								{#each csvValidFields as field}
									<option value={field} selected={field === csvUseLngField}>{field}</option>
								{/each}
							</select>
							<br/>

							<p><b>Latitude:</b></p>
							<select class='default' bind:value={csvUseLatField} style="width:100%;">
								<option value={null} selected={csvUseLatField === null}>Please select:</option>
								{#each csvValidFields as field}
									<option value={field} selected={field === csvUseLatField}>{field}</option>
								{/each}
							</select>
							<br/><br/>
						</Cell>
					</Row>
				{/if}
				<Row>
					<Cell>Color:</Cell>
					<Cell>
						<div class='p-5'>
							<div class='color-sq' style="background-color: rgba({color[0]*255}, {color[1]*255},{color[2]*255}, {color[3]});"
										on:click={toggleColorPickerVisibility}>
							</div>
							(<a href="/" on:click|preventDefault={toggleColorPickerVisibility}>{#if !colorPickVisible}edit{:else}close{/if}</a>)
						</div>
						{#if colorPickVisible}
							<div class='p-5'>
								<HsvPicker on:colorChange={(rgba) => {
									console.log(rgba);
									color[0] = rgba.detail.r/255.0;
									color[1] = rgba.detail.g/255.0;
									color[2] = rgba.detail.b/255.0;
									color[3] = rgba.detail.a;
									colorHex = ColorHelper.rgbToHex(rgba.detail.r, rgba.detail.g, rgba.detail.b);
									console.log(colorHex);
								}} startColor={colorHex}/>
							</div>
						{/if}
					</Cell>
				</Row>

			</Body>
		</DataTable>

		{#if error && errorMessage.length > 0}
			<div class="bg-error" style={errorStyle}>{@html errorMessage}</div>
		{/if}

		<Button color="primary" variant="unelevated" style={style} on:click={onSubmit}>
			<Label>Add</Label>
		</Button>
	</Form>

</ModalWindow>
